// extracted by mini-css-extract-plugin
export var active = "meal-planer-template-list-module--active--HfEFV";
export var inactive = "meal-planer-template-list-module--inactive--5brRe";
export var label = "meal-planer-template-list-module--label--OIXGA";
export var name = "meal-planer-template-list-module--name--okIc8";
export var templateListItem = "meal-planer-template-list-module--template-list-item--VUVmT";